module.exports = __webpack_public_path__ + "img/banner-1-m.53364786.jpg";